import React, { useState } from 'react';
import FoodWheel from './FoodWheel';

const Header: React.FC = () => {
    const [isFoodWheelOpen, setIsFoodWheelOpen] = useState(false);

    return (
        <>
            <header className="bg-gradient-to-r from-pink-100 via-pink-200 to-rose-200 shadow-lg border-b border-pink-200">
                <div className="container mx-auto px-6 py-6">
                    <nav className="flex justify-center items-center">
                        <div className="flex items-center">
                            <div className="text-2xl mr-6">💕</div>
                            <ul className="flex items-center space-x-8">
                                <li className="flex items-center">
                                    <a
                                        href="#chung-ta"
                                        className="relative px-6 py-3 text-pink-700 hover:text-pink-900 font-semibold text-lg transition-all duration-300 rounded-full hover:bg-white/50 hover:shadow-md group flex items-center"
                                    >
                                        Chúng ta
                                        <span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-gradient-to-r from-pink-500 to-rose-500 transition-all duration-300 group-hover:w-full group-hover:left-0"></span>
                                    </a>
                                </li>
                                <li className="flex items-center">
                                    <button
                                        onClick={() => setIsFoodWheelOpen(true)}
                                        className="relative px-6 py-3 text-pink-700 hover:text-pink-900 font-semibold text-lg transition-all duration-300 rounded-full hover:bg-white/50 hover:shadow-md group flex items-center"
                                    >
                                        Hôm nay ăn gì
                                        <span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-gradient-to-r from-pink-500 to-rose-500 transition-all duration-300 group-hover:w-full group-hover:left-0"></span>
                                    </button>
                                </li>
                            </ul>
                            <div className="text-2xl ml-6">💕</div>
                        </div>
                    </nav>
                </div>
            </header>

            <FoodWheel
                isOpen={isFoodWheelOpen}
                onClose={() => setIsFoodWheelOpen(false)}
            />
        </>
    );
};

export default Header; 